<template>
    <img v-if="cardUrl" class="CreditCardIcon" :src="cardUrl"/>
</template>

<script>
export default {
    name: 'CreditCardIcon',

    props: {
        brand: { type: String, default: null },
    },

    computed: {
        cardUrl() {
            const cardUrls = {
                visa: '/img/icons/visa.svg',
                amex: '/img/icons/american-express.svg',
                discover: '/img/icons/discover.svg',
                mastercard: '/img/icons/mastercard.svg',
                jcb: '/img/icons/jcb.svg',
                diners: '/img/icons/diners-club.svg',
            };
            return cardUrls[this.brand];
        },
    },
};
</script>

<style lang="scss" scoped>
.CreditCardIcon {
    width: auto;
    height: 1em;

    // Font scaling for Safari
    max-width: 100%;
    max-height: 100%;
}
</style>
